import {APP_ROOT_ELEMENT_ID} from "../../../services/application/application.service.interface";

export function composeModalId(id: string): string {
    return "MODAL_CONTENT_" + id;
}

export function getModalRootElement(id: string): HTMLElement {
    return document.getElementById(composeModalId(id))!
}


export function getModalAppElement(): HTMLElement {
    return document.getElementById(APP_ROOT_ELEMENT_ID)!;
}